/**
 * Product Card La Europea — quantity selector + add to cart
 * Guard: only initializes once even if script is loaded multiple times.
 */
(function() {
  if (window.__leCardInit) return;
  window.__leCardInit = true;

  document.addEventListener('click', function(e) {
    // Quantity buttons
    var qtyBtn = e.target.closest('.le-qty__btn');
    if (qtyBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var qty = qtyBtn.closest('.le-qty');
      var valueEl = qty.querySelector('[data-qty-value]');
      var val = parseInt(valueEl.textContent, 10) || 1;

      if (qtyBtn.dataset.action === 'increase') {
        val++;
      } else if (qtyBtn.dataset.action === 'decrease' && val > 1) {
        val--;
      }
      valueEl.textContent = val;
      return false;
    }

    // Add to cart
    var atcBtn = e.target.closest('.le-atc-btn');
    if (atcBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (atcBtn.disabled) return false;

      var card = atcBtn.closest('.le-card');
      var variantId = atcBtn.dataset.variantId;
      var qtyEl = card.querySelector('[data-qty-value]');
      var quantity = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: quantity
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function() {
        atcBtn.textContent = 'Agregado';
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Agregar al carrito';
        }, 1500);

        // Dispatch Horizon theme's cart:update event so cart-icon, cart-drawer
        // and cart-items-component all react (update count, open drawer, re-render).
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'le-card-' + variantId,
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: atcBtn.dataset.productId,
              variantId: variantId
            }
          }
        }));
      })
      .catch(function() {
        atcBtn.textContent = 'Error';
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Agregar al carrito';
        }, 1500);
      });

      return false;
    }
  }, true); // Use capture phase to intercept before <a> link click
})();
